import React from 'react';
import { FormPreset } from '@form-engine/core-application/types/form';
import { useMaskContext } from '@form-engine/builder-mask/hooks/use-mask';
import { Col, Row } from 'react-bootstrap';
import BuilderFormPresetPreview from '../form-preset-preview';
import BuilderNameProperty from '@form-engine/builder-mask/components/properties/name';
// import BuilderTagsProperty from '@form-engine/builder-mask/components/properties/tags';
import BuilderStringProperty from '@form-engine/builder-mask/components/properties/string';
import {
    MaskConfigContextValue,
    MaskConfigProvider,
} from '@form-engine/builder-mask/hooks/use-mask-config';
import FormPresetSchema from './schema';

const maskConfig = {
    schema: FormPresetSchema.pick({ name: true, description: true }),
} satisfies MaskConfigContextValue;

export default function BuilderFormPresetMask() {
    const { state: preset } = useMaskContext<FormPreset>();
    return (
        <MaskConfigProvider value={maskConfig}>
            <Row>
                <Col sm={6}>
                    {preset && <BuilderFormPresetPreview preset={preset} />}
                </Col>
                <Col sm={6}>
                    <BuilderNameProperty />
                    {/* <BuilderTagsProperty /> */}
                    <BuilderStringProperty
                        as="textarea"
                        rows="3"
                        stacked
                        propertyName="description"
                        label="Description"
                    />
                </Col>
            </Row>
        </MaskConfigProvider>
    );
}
